import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgHistoryIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m20.5 13.3333-1.7254-1.7777-1.7264 1.7777M19.033 12c0 4.4183-3.4772 8-7.7665 8S3.5 16.4183 3.5 12s3.4772-8 7.7665-8c2.8494 0 5.3404 1.5806 6.6917 3.937m-6.6917-.3814V12l2.5889 1.7778"
    />
  </svg>
);
export default SvgHistoryIcon;
